import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import LoadMask from '../../../../components/LoadMask';
import PlatformUserForm from './PlatformUserForm';
import { getUpdatePlatformUserUI, getRemovePlatformUserUI } from '../../../../redux/selectors';
import { fetchPlatformUsers, fetchUpdatePlatformUser, fetchRemovePlatformUser, updatePlatformUserClear, removePlatformUserClear } from '../../../../redux/admin-platform-users';

class EditPlatformUserModal extends Component {
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(updatePlatformUserClear());
    dispatch(removePlatformUserClear());
  }

  _submit = ({ id, name, email, companyId, divisions, roles, isCustomerService }) => {
    const { dispatch, onDismiss } = this.props;

    dispatch(fetchUpdatePlatformUser(id, name, email, companyId, divisions, roles, isCustomerService)).then(
      () => {
        onDismiss();
        dispatch(fetchPlatformUsers());
      },
      // reject
      () => { },
    );
  }

  _removeUser = (userData) => {
    const { dispatch, onDismiss } = this.props;

    dispatch(fetchRemovePlatformUser(userData.id)).then(
      () => {
        onDismiss();
        dispatch(fetchPlatformUsers());
      },
      // reject
      () => { },
    );
  }

  render() {
    const {
      updateUI,
      removeUI,
      userData,
      companies,
      onDismiss,
    } = this.props;

    return (
      <Modal
        title="Editar usuário"
        size="small"
        onBackdropClick={onDismiss}
      >
        <PlatformUserForm
          errorMessage={updateUI.error || removeUI.error}
          userData={userData}
          companies={companies}
          onDismiss={onDismiss}
          onSubmit={this._submit}
          onRemove={this._removeUser}
        />
        {
          (updateUI.isFetching || removeUI.isFetching) &&
          <LoadMask text={updateUI.isFetching ? 'Salvando...' : 'Removendo...'} />
        }
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    updateUI: getUpdatePlatformUserUI(state),
    removeUI: getRemovePlatformUserUI(state),
  };
}

export default connect(mapStateToProps)(EditPlatformUserModal);
